export const ACCENTS = {
  softBlue: 'Soft blue',
  ink: 'Ink',
  oxblood: 'Oxblood',
  ultramarine: 'Ultramarine',
  forest: 'Forest',
  ochre: 'Ochre',
  plum: 'Plum',
  teal: 'Teal',
} as const;
export type Accent = keyof typeof ACCENTS;
export type Appearance = 'system' | 'light' | 'dark';
export interface ReaderPreferences {
  appearance: Appearance;
  accent: Accent;
  railSide: 'left' | 'right';
  /** Whether the sidebar is pinned at desktop widths. */
  menu: 'shown' | 'hidden';
  typeScale: number;
  contentScale: number;
}
export const READER_KEY = 'knowsh.reader';
export const DEFAULT_READER: ReaderPreferences = {
  appearance: 'system',
  accent: 'softBlue',
  railSide: 'right',
  menu: 'shown',
  typeScale: 1,
  contentScale: 1,
};
const scale = (value: unknown, min: number, max: number) =>
  typeof value === 'number' && Number.isFinite(value) ? Math.min(max, Math.max(min, value)) : 1;

export function readPreferences(raw: string | null): ReaderPreferences {
  try {
    const value = JSON.parse(raw ?? '{}');
    return {
      appearance: ['system', 'light', 'dark'].includes(value.appearance)
        ? value.appearance
        : 'system',
      accent: Object.hasOwn(ACCENTS, value.accent) ? value.accent : 'softBlue',
      railSide: value.railSide === 'left' ? 'left' : 'right',
      menu: value.menu === 'hidden' ? 'hidden' : 'shown',
      typeScale: scale(value.typeScale, 0.85, 1.5),
      contentScale: scale(value.contentScale, 0.7, 1.5),
    };
  } catch {
    return DEFAULT_READER;
  }
}
